import RussianFont from './Russian.2022.ttf';

export const Fonts = {
  Russian2022: RussianFont
}; 